var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseEvent } from './base-event';
/**
 * Arguments for the `noteHover` event.
 */
var NoteHoverEvent = /** @class */ (function (_super) {
    __extends(NoteHoverEvent, _super);
    /**
     * @hidden
     */
    function NoteHoverEvent(e, target) {
        var _this = _super.call(this, target) || this;
        _this.category = e.category;
        _this.dataItem = e.dataItem;
        _this.series = e.series;
        _this.value = e.value;
        _this.visual = e.visual;
        return _this;
    }
    return NoteHoverEvent;
}(BaseEvent));
export { NoteHoverEvent };
//# sourceMappingURL=note-hover-event.js.map